"use strict";

exports.__esModule = true;
exports.default = void 0;
function isNetworkError(xhr) {
  if (!xhr) {
    return false;
  }
  return xhr.readyState !== 0 && xhr.readyState !== 4 || xhr.status === 0;
}
var _default = exports.default = isNetworkError;